const ACCESS_TOKEN = "ACCESS_TOKEN"

function saveToken(token) {
    window.sessionStorage.setItem(ACCESS_TOKEN, token)
}

function getToken() {
    const token = window.sessionStorage.getItem(ACCESS_TOKEN)
    return token
}

function deleteToken() {
    window.sessionStorage.removeItem(ACCESS_TOKEN);
}

export { saveToken, getToken, deleteToken }